// extracted by mini-css-extract-plugin
export default {"container":"PaginationScroll_container__3HapA","allResults":"PaginationScroll_allResults__Yc5Ob","wrapper":"PaginationScroll_wrapper__qg5OC"};